import {Injectable, PipeTransform} from '@angular/core';

import {BehaviorSubject, Observable, of, Subject} from 'rxjs';
import {DecimalPipe} from '@angular/common';
import {debounceTime, delay, switchMap, tap} from 'rxjs/operators';
import { TopicContent } from '../models/topic-content.model';
import { SortTable } from '../directives/sortable.directive';
import { TOPICCONTENTS } from 'app/pages/full-pages/admin/topic-content/list/list.component';

interface SearchResult {
  topiccontents: TopicContent[];
  total: number;
}

interface State {
  page: number;
  pageSize: number;
  searchTerm: string;
  sortColumn: string;
  sortDirection: SortTable;
}

function compare(v1, v2) {
  return v1 < v2 ? -1 : v1 > v2 ? 1 : 0;
}

function sort(topiccontents: TopicContent[], column: string, direction: string): TopicContent[] {
  if (direction === '') {
    return topiccontents;
  }
}

function matches(topicContent: TopicContent, term: string, pipe: PipeTransform) {
  return topicContent.title.toLowerCase().includes(term)
    || pipe.transform(topicContent.type).includes(term)
    || pipe.transform(topicContent.id).includes(term);
}

@Injectable({providedIn: 'root'})
export class TopicContentService {
  private _loading$ = new BehaviorSubject<boolean>(true);
  private _search$ = new Subject<void>();
  private topicContentss$ = new BehaviorSubject<TopicContent[]>([]);
  private _total$ = new BehaviorSubject<number>(0);

  private _state: State = {
    page: 1,
    pageSize: 4,
    searchTerm: '',
    sortColumn: '',
    sortDirection: ''
  };

  constructor(private pipe: DecimalPipe) {
    this._search$.pipe(
      tap(() => this._loading$.next(true)),
      debounceTime(200),
      switchMap(() => this._search()),
      delay(200),
      tap(() => this._loading$.next(false))
    ).subscribe(result => {
      // this.topicContents$.next(result.topicContents);
      this._total$.next(result.total);
    });

    this._search$.next();
  }

  get topicContents$() { return this.topicContentss$.asObservable(); }
  get total$() { return this._total$.asObservable(); }
  get loading$() { return this._loading$.asObservable(); }
  get page() { return this._state.page; }
  get pageSize() { return this._state.pageSize; }
  get searchTerm() { return this._state.searchTerm; }

  set page(page: number) { this._set({page}); }
  set pageSize(pageSize: number) { this._set({pageSize}); }
  set searchTerm(searchTerm: string) { this._set({searchTerm}); }
  set sortColumn(sortColumn: string) { this._set({sortColumn}); }
  set sortDirection(sortDirection: SortTable) { this._set({sortDirection}); }

  private _set(patch: Partial<State>) {
    Object.assign(this._state, patch);
    this._search$.next();
  }

  private _search(): Observable<SearchResult> {
    const {sortColumn, sortDirection, pageSize, page, searchTerm} = this._state;

    // 1. sort
    let topiccontents = sort(TOPICCONTENTS, sortColumn, sortDirection);

    // 2. filter
    topiccontents = topiccontents.filter(topicContent => matches(topicContent, searchTerm, this.pipe));
    const total = topiccontents.length;

    // 3. paginate
    topiccontents = topiccontents.slice((page - 1) * pageSize, (page - 1) * pageSize + pageSize);
    return of({topiccontents, total});
  }
}
